import React from 'react';
import '../../ComponentStyles/MainPage.css';
import { Container, Button, Card, Form } from 'react-bootstrap';
import Slider from 'react-slick';
import { FaUsers, FaCode, FaClipboardCheck, FaChalkboardTeacher } from 'react-icons/fa';
import OurServicesSection from './OurServicesSection';
import AboutUsSection from './AboutUsSection';
import ContactSection from './ContactSection';
import FooterSection from './FooterSection';

const MainPage = () => {
  return (
    <div className='page-section-main-container'>
      {/* Hero Section */}
      <div className='hero-section' style={{padding: '2rem 2rem', color: '#F5F5F5', textAlign: 'center' }}>
        <h1>Empowering Your Business with solutions that make sense.</h1>
        <Button variant='primary' size='md' style={{marginTop: "10px"}}>Schedule a Free Consultation</Button>
      </div>

      <OurServicesSection />
      <AboutUsSection />
      <ContactSection />

      {/* Footer Section */}
      <FooterSection />
    </div>
  );
};

export default MainPage;